export function addBusinessDays(startDate, days) {
    let date = new Date(startDate);
    let added = 0;

    while (added < days) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        // 0 = Sunday, 6 = Saturday
        if (day !== 0 && day !== 6) {
            added++;
        }
    }
    return date;
}
